export default __webpack_public_path__ + "static/media/locationbutton.b7ad8ba9.png";